module.exports = __webpack_public_path__ + "d308073b/img/file-icon.c085e21e.svg";